import React, { useState } from 'react';
import { Table, Button, Input, Select, Tag, message } from 'antd';
import MonthSelectionForm from './SearchEmployee';
import moment from 'moment';
// import './App.css';

const { Option } = Select;

const correctionData = [
  {
    key: '1',
    name: 'Priya Sharma',
    date: 'June 10',
    inTime: '9:15 AM',
    outTime: '4:20 PM',
    reason: 'Short Leave',
  },
  {
    key: '2',
    name: 'Ravi Kumar',
    date: 'June 12',
    inTime: '10:02 AM',
    outTime: '7:01 PM',
    reason: 'Regularize',
  },
  {
    key: '3',
    name: 'Aditi Mehra',
    date: 'June 11',
    inTime: '9:35 AM',
    outTime: '4:45 PM',
    reason: 'Short Leave',
  },
  {
    key: '4',
    name: 'Muskan Garg',
    date: 'June 14',
    inTime: '10:05 AM',
    outTime: '7:00 PM',
    reason: 'Regularize',
  },
  {
    key: '5',
    name: 'Aditi Mehra',
    date: 'June 16',
    inTime: '11:30 AM',
    outTime: '6:20 PM',
    reason: 'Short Leave',
  },
  {
    key: '6',
    name: 'Ravi Kumar',
    date: 'June 19',
    inTime: '9:30 AM',
    outTime: '2:10 PM',
    reason: 'Half Day',
  },
];

const correctionColumns = [
  { title: 'Employee Name', dataIndex: 'name' },
  { title: 'Date', dataIndex: 'date' },
  { title: 'In Time', dataIndex: 'inTime' },
  { title: 'Out Time', dataIndex: 'outTime' },
  { title: 'Reason', dataIndex: 'reason' },
  {
    title: 'Action',
    render: () => (
      <>
        <Button type="primary" size="small" style={{ marginRight: 8 }}>Approve</Button>
        <Button danger size="small">Reject</Button>
      </>
    ),
  },
];

const attendanceData = [
  {
    name: 'Priya Sharma',
    records: ['Present', 'Present', 'Late', 'Absent', 'Late', 'Present', 'Present', 'Present'],
  },
  {
    name: 'Ravi Kumar',
    records: ['Late', 'Absent', 'Present', 'Present', 'Late', 'Absent', 'Present', 'Present'],
  },
  {
    name: 'Aditi Mehra',
    records: ['Present', 'Present', 'Present', 'Present', 'Present', 'Present', 'Present', 'Present'],
  },
  {
    name: 'Muskan Garg',
    records: ['Present', 'Present', 'Present', 'Present', 'Late', 'Present', 'Present', 'Present'],
  },
  {
    name: 'Aditi Mehra 2',
    records: ['Absent', 'Absent', 'Absent', 'Absent', 'Late', 'Present', 'Present', 'Present'],
  },
  {
    name: 'Ravi Kumar 2',
    records: ['Late', 'Late', 'Late', 'Late', 'Late', 'Present', 'Present', 'Present'],
  },
];

// const statusColor = (status) => {
//   if (status === 'Present') return <Tag color="green">● {status}</Tag>;
//   if (status === 'Late') return <Tag color="gold">● {status}</Tag>;
//   return <Tag color="red">● {status}</Tag>;
// };
const statusColor = (status) => {
  switch (status) {
    case 'Present':
      return 'status-present';
    case 'Late':
      return 'status-late';
    case 'Absent':
      return 'status-absent';
    default:
      return '';
  }
};

const dateHeaders = ['June 18', 'June 17', 'June 16', 'June 15', 'June 14', 'June 13', 'June 12', 'June 11'];

const topIssues = [
  { name: 'Anshul Sharma', issue: '4 late arrivals' },
  { name: 'Vivek Singh', issue: '3 corrections' },
  { name: 'Vivek Singh', issue: '6 late arrivals' },
];

const ADashboard = () => {

    const [isLoading, setIsLoading] = useState(false);

  const handleFormSubmit = (values) => {
    setIsLoading(true);
    console.log('Form values submitted:', values);
    
    // Simulate API call
    setTimeout(() => {
      message.success(
        `Submitted: Search Month - ${values.searchMonth}, Calendar Month - ${values.calendarMonth}`
      );
      setIsLoading(false);
    }, 1500);
  };
  return (
    <div  className='p-4 pt-2' >
      <h2 className='table-title mb-4 '>Correction Request Inbox</h2>
      <Table dataSource={correctionData} columns={correctionColumns} pagination={false} bordered />
      <div className='flex mt-5 mb-1 justify-between'>

      <h2 className='table-title m-0 '>Team Calendar</h2>
       <MonthSelectionForm 
        onSubmit={handleFormSubmit} 
        loading={isLoading}
        initialValues={{ calendarMonth: moment() }}
        
      />
      </div>
      {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <Input.Search placeholder="Search" style={{ width: 200 }} />
        <Select defaultValue="Month" style={{ width: 120 }}>
          <Option value="Month">Month</Option>
        </Select>
      </div> */}
      <div className='color-status-table'> 

        <Table
          dataSource={attendanceData.map((item, i) => ({
            key: i,
            name: item.name,
            ...item.records.reduce((acc, val, idx) => {
              acc[`day${idx}`] = val;
              return acc;
            }, {}),
          }))}
          columns={[
            {
              title: 'Employee Name',
              dataIndex: 'name',
            },
            ...dateHeaders.map((date, idx) => ({
              title: date,
              dataIndex: `day${idx}`,
              render: (val) => (
                <div className='relative'>
               <div className='absolute right-0 top-1' style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 4 }}>
                <svg
                  width="7"
                  height="6"
                  viewBox="0 0 7 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="3.5" cy="3" r="3" fill="currentColor" />
                </svg>
                <span>{val}</span>
              </div>
              </div>
              ),
              onCell: (record) => ({
                className: statusColor(record[`day${idx}`]),
              }),
            })),
          ]}
          pagination={{ pageSize: 5 }}
          bordered
        />

        </div>

      <h3 className='table-title mb-4' style={{ marginTop: 48 }}>Top Issues</h3>
      <ul>
        {topIssues.map((item, idx) => (
          <li key={idx}>
          <div className='flex justify-between font-bold' >
           <div>   {item.name}</div> <div style={{ color: 'red' }}>{item.issue}</div>
          </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ADashboard;